import { Fragment, useCallback, useEffect, useState } from 'react';

import { type Journey } from '../../.generated/types';
import { type Environment } from '../server/utils/environment';
import { type SardineOnCompleted, type SardineOnError, setupSardine, updateSardineSession } from '../server/vendors';

export interface SardineProps {
	sessionKey: string;
	environment: Environment;
	journey: Journey;
	onCompleted?: () => void;
}

export function Sardine(props: SardineProps) {
	const { sessionKey, environment, journey, onCompleted } = props;
	const [initialized, setInitialized] = useState<boolean>(false);
	const [errored, setErrored] = useState<boolean>(false);

	const internalOnCompleted = useCallback<SardineOnCompleted>(() => {
		onCompleted?.();
	}, [onCompleted]);

	const onError = useCallback<SardineOnError>(() => {
		setErrored(true);
	}, [setErrored]);

	useEffect(() => {
		if (!initialized && !errored) {
			setupSardine({
				environment: environment,
				onError: onError,
			});
			setInitialized(true);
		}
	}, [environment, errored, initialized, onError]);

	useEffect(() => {
		if (!errored && initialized) {
			updateSardineSession({ sessionKey, journey, onCompleted: internalOnCompleted, onError });
		}
	}, [sessionKey, journey, errored, initialized, internalOnCompleted, onError]);

	return <Fragment />;
}
